import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild, ViewContainerRef} from '@angular/core';
import {ComponentService} from '../../services/component-highlight-stack.service';
import {ModulesStateService} from 'app/shared/content-renderer/services/modules-state.service';
import {EntityDataChangeMeta, EntityDataStoreService} from '../../services/entity-data-store.service';
import {GenericCrudService} from '../../../services/generic-crud.service';
import {PermissionService} from '../../../services/permission/permission.service';
import {ExecutorService} from 'app/core/executor/executor.service';
// tslint:disable-next-line:max-line-length
import {GenericElementValidationExecutionStepsFactory} from 'app/shared/content-renderer/services/generic/generic-element-validation-execution-steps-factory';
import {EntityValidator, EntityValidatorStatus} from '../../../validators/services/entity-validator';
import {Element} from '../../../services/element/element';
import {ModuleElement} from '../../../services/module/module-element';
import {UserSessionService} from '../../../../core/service/user-session.service';
import {ElementSaveStatus, GenericElementAbstract} from '../generic-element-abstract.component';
import {Observable, of as observableOf} from 'rxjs';
import {ElementType} from '../../services/ElementContext';
import {ElementsStackService} from '../../services/elements-stack.service';
import {ToolbarComponent} from '@syncfusion/ej2-angular-navigations';
import {ClickEventArgs} from '@syncfusion/ej2-buttons';

import {
  AnnotationDataFormat,
  AnnotationService,
  BookmarkViewService,
  LinkAnnotationService,
  LoadEventArgs,
  MagnificationService,
  NavigationService,
  PageChangeEventArgs,
  PdfViewerComponent,
  PrintService,
  TextSearchService,
  TextSelectionService,
  ThumbnailViewService,
  ToolbarService
} from '@syncfusion/ej2-angular-pdfviewer';
import {ChangeDetectorRefHelper} from '../../../helpers/change-detector-ref.helper';
import {AuthenticationService} from '../../../../core/authentication/authentication.service';
import {ToolbarSettingsModel} from '@syncfusion/ej2-pdfviewer/src/pdfviewer/pdfviewer-model';
import {DateHelper} from '../../../helpers/date.helper';
import {AbstractGenericGridComponent} from '../abstract-generic-grid.component';
import {AnnotationAddEventArgs, AnnotationRemoveEventArgs} from '@syncfusion/ej2-pdfviewer/src/pdfviewer';
import {environment} from '../../../../../environments';
import {DataSourceQueryParameter} from '../../../services/data-source/data-source';

@Component({
  selector: 'app-pdf-viewer',
  styleUrls: ['./generic-pdf-viewer.component.scss'],
  templateUrl: './generic-pdf-viewer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    LinkAnnotationService, BookmarkViewService, MagnificationService,
    ThumbnailViewService, ToolbarService, NavigationService, AnnotationService, TextSearchService, TextSelectionService, PrintService,
    GenericElementValidationExecutionStepsFactory,
    ExecutorService
  ]
})
export class GenericPdfViewerComponent extends GenericElementAbstract {

  @Input() element: Element;
  @Input() moduleElement: ModuleElement;
  @Input() pdfToolbar: string;

  @ViewChild('gridContainer', {static: false}) set gridContainer(container: ElementRef) {
    this._container = container;

    if (this._container && this._container.nativeElement) {
    }
  }
  @ViewChild('customToolbar', {static: false}) protected customToolbar: ToolbarComponent;
  @ViewChild('canvasElement', {static: false}) protected canvasElement: ElementRef;
  @ViewChild('pdfViewerComponent', {static: false}) protected pdfViewerComponent: PdfViewerComponent;

  public _container: ElementRef = null;

  protected toolbarContextName = 'genericPdfViewer';
  public elementType: ElementType = ElementType.PdfViewer;
  public service = environment.pdfViewerUrl;
  public document = null;
  public customStamps = [];
  public toolbarSettings: ToolbarSettingsModel;
  public enableToolbar = false;
  public enableAnnotationToolbar = false;
  public author = 'Unknown';
  public documentsStampsComponent?: AbstractGenericGridComponent = null;
  public stamps: any[] = [];

  @Input()
  get entity() {
    return this.entityObj;
  }

  set entity(entity) {
    this.entityObj = entity;
    if (this.entityObj && this.entityObj.contentUrl && this.entityObj.contentUrl.endsWith('.pdf')) {
      this.document = this.entityObj.contentUrl;
    } else {
      this.document = null;
    }
    ChangeDetectorRefHelper.detectChanges(this)
  }

  public src: any;
  private entityObj: any;

  constructor(
    protected componentService: ComponentService,
    protected viewContainerRef: ViewContainerRef,
    protected entityDataStore: EntityDataStoreService,
    protected modulesStateService: ModulesStateService,
    protected executorService: ExecutorService,
    protected genericElementValidationExecutionStepsFactory: GenericElementValidationExecutionStepsFactory,
    protected entityValidator: EntityValidator,
    protected genericCrudService: GenericCrudService,
    protected userSession: UserSessionService,
    protected permissionService: PermissionService,
    protected elementRef: ElementRef,
    protected authenticationService: AuthenticationService,
    public cdr: ChangeDetectorRef,
    protected elementsStackService: ElementsStackService
  ) {
    super(componentService, viewContainerRef, entityDataStore, modulesStateService,
      executorService, genericElementValidationExecutionStepsFactory,
      entityValidator, genericCrudService,
      userSession, permissionService, cdr
    );
  }

  onAfterSave(): Observable<any> {
    console.log(this.pdfViewerComponent.annotations);
    return observableOf(null);

    // return Observable.create((observer) => {
    //   this.createdEntities = [];
    //   this.updatedEntities = [];
    //   this.draftDeletedEntities = [];
    //
    //   this.entityDirtyStore.removeFQN(this.getElementDatamodelEntityName());
    //   this.requestCachingService.removeByExpression(this.getElementDataModelApiRoute());
    //
    //   observer.next();
    //   observer.complete();
    // });
  }

  onChange(changeMeta: EntityDataChangeMeta): Observable<any> {
    return observableOf(null);
  }

  public ngOnInit() {
    super.ngOnInit();
    this.elementContext = this.elementsStackService.createContext(this);
    this.elementsStackService.remove(this.elementContext).add(this.elementContext);
    this.author = this.authenticationService.currentUser.username;
    this.loadStamps();
    if (this.pdfToolbar === 'midi') {
      this.toolbarSettings = {
        showTooltip: true,
        toolbarItems: ['PageNavigationTool', 'DownloadOption', 'PrintOption', 'UndoRedoTool',
          'AnnotationEditTool', 'MagnificationTool', 'CommentTool', 'SearchOption'],
        annotationToolbarItems: ['HighlightTool', 'UnderlineTool',
          'ShapeTool', 'ColorEditTool', 'AnnotationDeleteTool',
          'StampAnnotationTool', 'HandWrittenSignatureTool', 'InkAnnotationTool',
          'FreeTextAnnotationTool', 'FontFamilyAnnotationTool', 'FontSizeAnnotationTool',
          'FontStylesAnnotationTool', 'FontAlignAnnotationTool', 'FontColorAnnotationTool',
          'CommentPanelTool']
      };
      this.enableToolbar = true;
      this.enableAnnotationToolbar = true;
    } else if (this.pdfToolbar === 'mini') {
      this.toolbarSettings = {
        showTooltip: false,
        toolbarItems: [],
        annotationToolbarItems: []
      }
    } else if (this.pdfToolbar === 'full') {
      this.toolbarSettings = {
        showTooltip: true,
        toolbarItems: ['OpenOption', 'PageNavigationTool', 'MagnificationTool', 'PanTool', 'SelectionTool',
          'SearchOption', 'PrintOption', 'DownloadOption', 'UndoRedoTool', 'AnnotationEditTool', 'CommentTool', 'SubmitForm'],
        annotationToolbarItems: ['HighlightTool', 'UnderlineTool', 'StrikethroughTool', 'ShapeTool', 'CalibrateTool',
          'ColorEditTool', 'StrokeColorEditTool', 'ThicknessEditTool', 'OpacityEditTool', 'AnnotationDeleteTool',
          'StampAnnotationTool', 'HandWrittenSignatureTool', 'InkAnnotationTool', 'FreeTextAnnotationTool', 'FontFamilyAnnotationTool',
          'FontSizeAnnotationTool', 'FontStylesAnnotationTool', 'FontAlignAnnotationTool', 'FontColorAnnotationTool', 'CommentPanelTool']
      };
      this.enableToolbar = true;
      this.enableAnnotationToolbar = true;
    }
    const currentModule = this.modulesStateService.getByComponent(this);
    for (const component of currentModule.getComponents()) {
      if (component instanceof AbstractGenericGridComponent && component.getElementDatamodel().name === 'DmsBundle.DocumentsStamps') {
        this.documentsStampsComponent = component;
      }
    }
  }

  public ngOnDestroy() {
    super.ngOnDestroy();
    this.elementsStackService.remove(this.elementContext);
  }

  doValidate(): Observable<EntityValidatorStatus> {
    return observableOf(null);
  }

  getSelectedEntity(): any {
  }

  hasChanges(checkEmbedded: boolean): boolean {
    return false;
  }

  onRefresh(): Observable<any> {
    return observableOf(null);
  }

  onSave(): Observable<ElementSaveStatus> {
    return observableOf(null);
  }

  recheckToolbarItems(): void {
  }

  public previousClicked(e: ClickEventArgs): void {
    this.pdfViewerComponent.navigation.goToPreviousPage();
  }

  public nextClicked(e: ClickEventArgs): void {
    this.pdfViewerComponent.navigation.goToNextPage();
  }

  public printClicked(e: ClickEventArgs): void {
    this.pdfViewerComponent.print.print();
  }

  public onCurrentPageBoxClicked(e: ClickEventArgs): void {
    (document.getElementById('currentPage') as HTMLInputElement).select();
  }

  public downloadClicked(e: ClickEventArgs): void {
    const fileName: string = (document.getElementById('fileUpload') as HTMLInputElement).value.split('\\').pop();
    if (fileName !== '') {
      this.pdfViewerComponent.fileName = fileName;
    }
    this.pdfViewerComponent.download();
  }

  public onCurrentPageBoxKeypress(e: KeyboardEvent): boolean {
    if ((e.which < 48 || e.which > 57) && e.which !== 8 && e.which !== 13) {
      e.preventDefault();
      return false;
    } else {
      // tslint:disable-next-line:radix
      const currentPageNumber: number = parseInt((document.getElementById('currentPage') as HTMLInputElement).value);
      if (e.which === 13) {
        if (currentPageNumber > 0 && currentPageNumber <= this.pdfViewerComponent.pageCount) {
          this.pdfViewerComponent.navigation.goToPage(currentPageNumber);
        } else {
          // tslint:disable-next-line:max-line-length
          (document.getElementById('currentPage') as HTMLInputElement).value = this.pdfViewerComponent.currentPageNumber.toString();
        }
      }
      return true;
    }
  }

  public pageChanged(e: PageChangeEventArgs): void {
    if (this.pdfToolbar === 'mini') {
      (document.getElementById('currentPage') as HTMLInputElement).value = this.pdfViewerComponent.currentPageNumber.toString();
      this.updatePageNavigation();
    }
  }

  public documentLoaded(e: LoadEventArgs): void {
    if (this.pdfToolbar === 'mini') {
      document.getElementById('totalPage').textContent = 'of ' + this.pdfViewerComponent.pageCount;
      (document.getElementById('currentPage') as HTMLInputElement).value = this.pdfViewerComponent.currentPageNumber.toString();
      this.updatePageNavigation();
    }
  }

  private updatePageNavigation(): void {
    if (this.pdfViewerComponent.currentPageNumber === 1) {
      this.customToolbar.enableItems(document.getElementById('previousPage'), false);
      this.customToolbar.enableItems(document.getElementById('nextPage'), true);
    } else if (this.pdfViewerComponent.currentPageNumber === this.pdfViewerComponent.pageCount) {
      this.customToolbar.enableItems(document.getElementById('previousPage'), true);
      this.customToolbar.enableItems(document.getElementById('nextPage'), false);
    } else {
      this.customToolbar.enableItems(document.getElementById('previousPage'), true);
      this.customToolbar.enableItems(document.getElementById('nextPage'), true);
    }
  }

  private loadStamps() {
    this.genericCrudService.getEntities('dms/stamps', null, {embedded: 'files'}).subscribe((stamps) => {
      this.stamps = stamps;
      stamps.map( stamp => {
        this.customStamps.push({
          customStampName: stamp.name,
          customStampImageSource: stamp.files[0] ? stamp.files[0].link : ''
        });
      });
      ChangeDetectorRefHelper.detectChanges(this);
    });
  }

  public annotationAdd(event: AnnotationAddEventArgs) {
    if (this.documentsStampsComponent) {
      const addedAnnotationInCollection = this.pdfViewerComponent.annotationCollection.find((aAnnotation: any) => {
        return aAnnotation.annotationId === event.annotationId;
      });
      const emptyEntity = this.documentsStampsComponent.emptyEntity;
      emptyEntity['user'] = event.annotationSettings.author;
      emptyEntity['date'] = new Date();
      emptyEntity['annotationId'] = event.annotationId;
      emptyEntity['stamp'] = this.stamps.find((aStamp: any) => {
        return (aStamp.files[0] ? aStamp.files[0].link : '') === addedAnnotationInCollection.stampAnnotationPath;
      });
      this.documentsStampsComponent.addEntity(emptyEntity);
      this.documentsStampsComponent.recheckToolbarItems();
      ChangeDetectorRefHelper.detectChanges(this.documentsStampsComponent);
    }
  }

  public annotationRemove(event: AnnotationRemoveEventArgs) {
    if (this.documentsStampsComponent) {
      const entity = this.findEntityByAnnotationId(event.annotationId);
      this.documentsStampsComponent.removeEntity(entity);
      this.documentsStampsComponent.recheckToolbarItems();
      ChangeDetectorRefHelper.detectChanges(this.documentsStampsComponent);
    }
  }

  private findEntityByAnnotationId(annotationId: string) {
    if (this.documentsStampsComponent) {

      return this.documentsStampsComponent.getEntities().find((aEntity) => {
        return annotationId === aEntity.annotationId;
      });
    }
    return null;
  }

  private generateImage(text: string) {
    const context = this.canvasElement.nativeElement.getContext('2d');
    context.globalAlpha = 1.0;
    context.strokeStyle = 'rgb(10,17,40)';
    context.fillStyle = 'rgb(220,227,239)';
    context.fillRect(0, 0, 430, 80);
    context.globalAlpha = 1.0;
    context.strokeStyle = 'rgb(10,17,40)';
    context.fillStyle = 'rgb(26,39,96)';
    context.font = '30pt Open Sans, Helvetica Neue';
    context.fillText(text, 10, 40);
    context.font = 'italic 12pt Open Sans, Helvetica Neue';
    context.fillText(`By ${this.author} at ${DateHelper.formatDate(new Date(), 'd.m.yy')} ${DateHelper.formatTime(new Date(), false, true)}`, 10, 65);

    return this.canvasElement.nativeElement.toDataURL();
  }
}
